// extracted by mini-css-extract-plugin
export default {"checkboxes":"CheckboxGroupLayout_checkboxes__KIKdy"};